export class LeadTimeDtoResponse {
  unitOfMeasure: string;
  value: number;
  valueInHours?: number;
  valueInDays?: number;
}
